var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step2-container" },
    [
      _c(
        "div",
        {
          staticClass: "main-content-container no-scrollbar",
          on: { scroll: _vm.scrollToEnd }
        },
        [
          _c(
            "div",
            {
              staticClass: "content-header",
              class: [_vm.selectedAddonProducts.length > 0 ? "cart" : ""],
              attrs: { id: "jump1" }
            },
            [
              _c("img", {
                staticClass: "starburst lazyload",
                attrs: {
                  alt: "start here",
                  loading: "lazy",
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/start_here.svg?v=1732206158"
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-container",
              class: _vm.isSticking ? "sticky" : "",
              attrs: { id: "header-container" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "happybox-button white border",
                    class: _vm.totalCurrentFilters > 0 ? "selected" : "",
                    on: {
                      click: function($event) {
                        return _vm.showFilters()
                      }
                    }
                  },
                  [
                    _vm.totalCurrentFilters > 0
                      ? _c("img", {
                          staticClass: "purple",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                          }
                        })
                      : _c("img", {
                          staticClass: "normal",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                          }
                        }),
                    _vm._v(
                      "\n                    Filter Products\n                    "
                    ),
                    _vm.totalCurrentFilters > 0
                      ? _c("span", [
                          _vm._v("(" + _vm._s(_vm.totalCurrentFilters) + ")")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "happybox-button white border",
                    on: {
                      click: function($event) {
                        return _vm.showSort()
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"
                      }
                    }),
                    _vm._v("Sort Products")
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-container" }, [
            !_vm.addonProducts || _vm.addonProducts.length == 0
              ? _c(
                  "ul",
                  { staticClass: "products-container no-scrollbar" },
                  _vm._l(12, function(n) {
                    return _c(
                      "li",
                      { key: n },
                      _vm._l(12, function(n) {
                        return _c("AddonProductSkeleton", { key: n })
                      }),
                      1
                    )
                  }),
                  0
                )
              : _c(
                  "ul",
                  { staticClass: "products-container no-scrollbar" },
                  [
                    _vm.nonFilteredProducts.length > 0
                      ? _c("p", { staticClass: "other-gifts" }, [
                          _vm._v(_vm._s(_vm.breadcrumbText))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.sortedProducts, function(addonProduct) {
                      return _c(
                        "li",
                        { key: addonProduct.id },
                        [
                          _c("AddonProductNew", {
                            attrs: {
                              product: addonProduct,
                              cartProducts: _vm.selectedAddonProducts,
                              addCopy: _vm.addCopy
                            },
                            on: {
                              loadmodal: function($event) {
                                return _vm.openModal($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.nonFilteredProducts.length > 0
                      ? _c("p", { staticClass: "other-gifts" }, [
                          _vm._v("All Other Gifts")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.nonFilteredProducts, function(addonProduct) {
                      return _c(
                        "li",
                        { key: addonProduct.id },
                        [
                          _c("AddonProductNew", {
                            attrs: {
                              product: addonProduct,
                              cartProducts: _vm.selectedAddonProducts,
                              addCopy: _vm.addCopy
                            },
                            on: {
                              loadmodal: function($event) {
                                return _vm.openModal($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.selectedAddonProducts.length > 0
        ? _c("SideCartMobile", {
            attrs: { cartProducts: _vm.selectedAddonProducts },
            on: {
              openmodal: function($event) {
                return _vm.openModal($event)
              },
              changepage: function($event) {
                return _vm.changePage($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AddonProductModalMobile", {
        attrs: {
          showModal: _vm.showModal,
          selectedAddon: _vm.currentSelectedAddon,
          addonProducts: _vm.modalProducts,
          cartProducts: _vm.selectedAddonProducts,
          recommendedProducts: _vm.modalRecommendedProducts
        },
        on: {
          closemodal: function($event) {
            return _vm.closeModal()
          },
          changeselectedaddon: function($event) {
            return _vm.openModal($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.showBrandableModal == true && _vm.currentSelectedAddon != null
        ? _c("BrandableProductModal", {
            attrs: {
              selectedAddon: _vm.currentSelectedAddon,
              addonProducts: _vm.modalProducts,
              cartProducts: _vm.selectedAddonProducts,
              recommendedProducts: _vm.modalRecommendedProducts
            },
            on: {
              closemodal: function($event) {
                return _vm.closeModal()
              },
              changeselectedaddon: function($event) {
                return _vm.openModal($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("FiltersMobile", {
            attrs: {
              isSticking: _vm.isSticking,
              filteredPreAddons: _vm.filteredPreProducts,
              filteredAddons: _vm.sortedProducts
            },
            on: {
              goall: _vm.goAll,
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sortIsShown
        ? _c("SortMobile", {
            attrs: { isSticking: _vm.isSticking },
            on: {
              closefilter: function($event) {
                return _vm.showSort()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "title" }, [_vm._v("Build a Gift Box")]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v(
          "\n                    STEP 1 of 3: Add gifts!\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sticky-image-container" }, [
      _c("p", { staticClass: "steps" }, [
        _vm._v(
          "\n                    STEP 1 of 3: Add gifts!\n                "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }